import { useEffect, useState } from "react";
import resetAccesses from "../../../api/folder/resetAccesses";
import resetAllAccesses from "../../../api/folder/resetAllAccesses";
import { getOrRefreshFirebaseToken } from "../../../config/getFirebaseToken";
import manageViewers from "../../../api/folder/manageViewers";
import CustomAccordion from "../../../layout/CustomAccordion";
import AccessTable from "../FolderAccessTable";
import Dropzone3 from "../../../dropzones/DropZone3";
import updateDocDataFieldApi from "../../../api/database/updateDocDataFieldApi";
import uploadDropZoneTemporary from "../../../api/upload/uploadDropZoneTemporary";
import FolderAccessTable from "../FolderAccessTable";
import FolderAdminTable from "../FolderAdminTable";
import { isFolderAdmin } from "../FolderHelpers";
import manageViewersV2 from "../../../api/folder/manageViewersV2";
import Space from "../../../layout/Space";
import { DatePicker } from "antd";
import SecondaryButton from "../../../buttons/SecondaryButton";
import PrimaryButton from "../../../buttons/PrimaryButton";
import dayjs from "dayjs";
import SmallSpinner from "../../../loading/SmallSpinner";
import DatePickerGPT0 from "../../../textfields/DatePickerGPT0";
import {
  getArrayDocDataByRef,
  getFlutterTimeFromSeconds,
  getRefFromId,
} from "../../../models/DataFunctions";

export const FolderAccessManagement = ({
  orgData,
  userData,

  loading_drop,
  dropped_files,
  selected_dropped_files,
  setSelectedDroppedFiles,
  onDelete,
  access_loading,
  id,
  prefix,
  folderData,

  handleClickVariant,
  setAllBlocked,
  masterData,
  clientData,
  handleFetchData,
  partners,
  setLoadingDrop,
  setDroppedFiles,
  setDroppedExists,
  setEmailOpen,
}) => {
  const [adminLoading, setAdminLoading] = useState(null);
  const [access, setAccess] = useState([[]]);

  const [loadingData, setLoadingData] = useState(false);
  const [loadingData2, setLoadingData2] = useState(false);
  const [date_seconds, setDateSeconds] = useState(null);

  const [email, setEmail] = useState("");
  const [accesspersons, setAccessPersons] = useState([]);
  const [accessdocuments, setAccessDocuments] = useState([]);

  const onDropZone = async (files) => {
    setLoadingDrop(true);
    const token = await getOrRefreshFirebaseToken();

    let new_files = [];

    new_files = files.filter(
      (file) => !dropped_files.map((filed) => filed.name).includes(file.name)
    );

    let new_drop_files = [];

    for (let i = 0; i < new_files.length; i++) {
      let res = await uploadDropZoneTemporary(
        token,
        new_files[i],
        new_files[i].name,
        prefix
      );
      let url = res.url;
      let name = res.name;
      new_drop_files = [...new_drop_files, { url: url, name: name }];
    }
    let new_dropped_files = [...dropped_files, ...new_drop_files];
    setDroppedFiles(new_dropped_files);
    setSelectedDroppedFiles(new_dropped_files);

    setDroppedExists(true);

    setLoadingDrop(false);
  };
  const handlesetPersons = async () => {
    let accessperson =
      folderData.client_type !== "particulier"
        ? [clientData, ...partners]
        : [{ id: "particulier", name: "Particulier" }, ...partners];
    setAccessPersons(accessperson);
  };

  const handleInitiateAccess = async () => {
    let documents = await getArrayDocDataByRef(folderData.documents);
    let accessdocuments = [...documents];

    if (folderData.folder_type === "infiltro") {
      const thermal = {
        id: "thermal",
        name: "Documents étude thermique",
        state: folderData.thermal?.state,
        viewers_id: folderData.thermal?.viewers_id,
      };
      const modif_thermal = {
        id: "modif_thermal",
        name: "Mise à jour étude thermique",
        state: folderData.modif_thermal?.state,
        viewers_id: folderData.modif_thermal?.viewers_id,
      };
      accessdocuments = [thermal, ...documents];
      accessdocuments.push(modif_thermal);
    }

    setAccessDocuments(accessdocuments);

    await initiateAccess(accessdocuments, accesspersons, folderData);
  };
  useEffect(() => {
    handlesetPersons();
  }, [folderData, id]);

  useEffect(() => {
    if (accessdocuments && accesspersons && id && !accessLoading) {
      handleInitiateAccess();
    }
  }, [folderData, id, accesspersons]);
  const [accessLoading, setAccessLoading] = useState(null);

  const initiateAccess = async (accessdocuments, accesspersons, folderData) => {
    // Make a copy of the access array to avoid direct state mutations
    let newAccess = accessdocuments.map(() =>
      Array(accesspersons.length).fill(false)
    );

    accesspersons.forEach((person, personIndex) => {
      accessdocuments.forEach((doc, docIndex) => {
        // Check if person's ref.id exists in doc.viewers_id by comparing the ids
        const personHasAccess = (doc.viewers_id || []).some(
          (viewer_id) =>
            viewer_id === person?.id || person?.id === "particulier"
        );

        if (doc.id === "thermal" && personHasAccess) {
          newAccess[docIndex][personIndex] = true;
        } else if (doc.id === "modif_thermal" && personHasAccess) {
          newAccess[docIndex][personIndex] = true;
        } else if (personHasAccess) {
          newAccess[docIndex][personIndex] = true;
        } else {
          newAccess[docIndex][personIndex] = false;
        }
      });
    });

    // check if one of the person has no access to any document
    await checkBlockedAccess(
      newAccess,
      accesspersons,
      accessdocuments,
      folderData
    );
    setAccess(newAccess);
  };

  const checkBlockedAccess = async (
    access,
    accesspersons,
    accessdocuments,
    folderData
  ) => {
    let all_blocked = {};

    accesspersons.forEach((person, personIndex) => {
      all_blocked[personIndex] = true;
      accessdocuments.forEach((doc, docIndex) => {
        // Check if person's ref.id exists in doc.viewers_id by comparing the ids
        if (access[docIndex][personIndex] === true) {
          all_blocked[personIndex] = false;
        }
      });
    });

    // check if one of the person has no access to any document
    let all_blocked_bool =
      Object.values(all_blocked).length === 0 ||
      !Object.values(all_blocked).every((blocked) => blocked === false);

    setAllBlocked(all_blocked_bool);
  };

  const handleSaveAccess = async (access) => {
    setAccessLoading("all");
    let items = [];
    // add dicts with type, org_id, has_access, document_id
    for (let docIndex = 0; docIndex < accessdocuments.length; docIndex++) {
      for (
        let personIndex = 0;
        personIndex < accesspersons.length;
        personIndex++
      ) {
        const person = accesspersons[personIndex];
        if (person.id === "particulier") {
          continue;
        }
        const has_access = access[docIndex][personIndex];
        const document_id = accessdocuments[docIndex].id;
        items.push({
          type:
            accessdocuments[docIndex].id === "thermal"
              ? "thermal"
              : accessdocuments[docIndex].id === "modif_thermal"
                ? "modif_thermal"
                : "document",
          org_id: person.id,
          has_vision: has_access,
          document_id: document_id,
        });
      }
    }

    const token = await getOrRefreshFirebaseToken();
    await manageViewersV2(id, items, token, prefix);
    handleClickVariant("Accès mis à jour", "success");
    setAccessLoading(null);
  };

  const handleAccessChange = async (docIndex, personIndex) => {
    // Make a copy of the access array to avoid direct state mutations
    let newAccess = access.map((row) => [...row]);

    newAccess[docIndex][personIndex] = !newAccess[docIndex][personIndex];
    setAccess(newAccess);
    handleSaveAccess(newAccess);

    // Toggle the access value
  };

  const handleAdminChange = async (person_id) => {
    // Make a copy of the access array to avoid direct state mutations
    const admins_id = folderData.admins_id || [];
    let new_admins_id = [...admins_id];
    if (admins_id.includes(person_id)) {
      new_admins_id = admins_id.filter((admin_id) => admin_id !== person_id);
    } else {
      new_admins_id = [...admins_id, person_id];
    }
    await updateDocDataFieldApi(
      folderData.ref,
      "admins_id",
      new_admins_id,
      prefix
    );
    handleClickVariant(
      admins_id.includes(person_id)
        ? "Droits administrateurs retirés"
        : "Droits administrateurs donnés",
      "success"
    );

    // Toggle the access value
  };

  const handleResetAccess = async (person) => {
    setAccessLoading(person);
    const orgtargeted = accesspersons.find((org) => org.name === person);
    const token = await getOrRefreshFirebaseToken();
    await resetAccesses(id, orgtargeted.id, token, prefix);
    handleClickVariant("Accès réinitialisé", "success");
    setAccessLoading(null);
  };

  const handlesetAllAccess = async (value, person_index) => {
    setAccessLoading("all");
    // set all access to true or false for all documents for a person
    let person_id = accesspersons[person_index].id;
    let newAccess = access.map((row) => [...row]);
    accessdocuments.forEach((doc, docIndex) => {
      accesspersons.forEach((person, personIndex) => {
        if (person.id === person_id) {
          newAccess[docIndex][personIndex] = value;
        }
      });
    });

    setAccess(newAccess);
    await handleSaveAccess(newAccess);
    setAccessLoading(null);
  };

  const onChangeInterventionDate = async (date) => {
    setDateSeconds(date);
  };

  const handleReinitializeInterventionDate = async () => {
    setLoadingData2(true);

    await updateDocDataFieldApi(folderData.ref, "startdate", null, prefix);
    await updateDocDataFieldApi(folderData.ref, "enddate", null, prefix);
    handleClickVariant("Plage de disponibilité réinitialisée", "success");
    setLoadingData2(false);
    handleFetchData();
  };

  const handleDone = async () => {
    await updateDocDataFieldApi(folderData.ref, "rdv_state", "done", prefix);
    handleClickVariant("Dossier traité", "success");
    handleFetchData();
  };

  const handleConfirmInterventionDate = async () => {
    setLoadingData(true);

    let intervention_time_int = date_seconds;
    // now a timestamp for forestore using moment
    let dateintervention = getFlutterTimeFromSeconds(date_seconds);
    await updateDocDataFieldApi(
      folderData.ref,
      "intervention_time_int",
      intervention_time_int,
      prefix
    );
    await updateDocDataFieldApi(
      folderData.ref,
      "dateintervention",
      dateintervention,
      prefix
    );
    await updateDocDataFieldApi(folderData.ref, "rdv_state", "done", prefix);

    handleClickVariant("Date d'intervention enregistrée", "success");
    setLoadingData(false);
    setEmailOpen(true);
    handleFetchData();
  };

  return (
    <>
      {folderData.rdv_state === "wait" && (
        <div className="flex mb-8">
          {isFolderAdmin(orgData, folderData) && (
            <div className="flex relative cursor-default flex-col gap-2 rounded-2xl bg-white border border-red-300  h-fit w-full p-4 mt-4">
              <div className="flex flex-col p-2">
                <div className="flex flex-col ">
                  <div>
                    <div className=" rounded-xl mb-2 text-shadow_50  text-h3 font-semibold w-fit">
                      Le client a demandé un RDV
                    </div>
                    <div className=" rounded-xl  text-shadow_50  text-h3  w-fit">
                      Disponibilités
                    </div>
                    <div className=" rounded-xl  text-shadow_50   text-h3  w-fit">
                      {
                        // if type is string display, else convert to str
                        typeof folderData?.startdate === "object"
                          ? dayjs
                              .unix(folderData?.startdate?.seconds)
                              .format("DD/MM/YYYY")
                          : folderData?.startdate
                      }
                      -{" "}
                      {
                        // if type is string display, else convert to str
                        typeof folderData?.enddate === "object"
                          ? dayjs
                              .unix(folderData?.enddate?.seconds)
                              .format("DD/MM/YYYY")
                          : folderData?.enddate
                      }
                    </div>
                    <Space y={10} />
                    {folderData?.rdv_comment && (
                      <div className=" rounded-xl  text-shadow_50   text-h3  whitespace-pre-line bg-neutral-50 w-full p-2">
                        {folderData?.rdv_comment}
                      </div>
                    )}

                    <Space y={10} />
                  </div>
                </div>
                <div className="h-fit w-c300">
                  <DatePickerGPT0
                    format="DD/MM/YYYY" // Format for the date
                    onChange={onChangeInterventionDate}
                    seconds={date_seconds} // Use seconds for the date
                    defaultValue={null} // Default date range
                    minDateSeconds={folderData?.startdate?.seconds}
                    maxDateSeconds={folderData?.enddate?.seconds}
                    className="w-full"
                  />
                </div>{" "}
                <Space y={10} />
                <div className="flex flew-row gap-2 justify-between">
                  <SecondaryButton
                    className="w-fit"
                    onClick={handleReinitializeInterventionDate}
                  >
                    Supprimer les limites de RDV
                    <SmallSpinner loading={loadingData2} />
                  </SecondaryButton>
                  <PrimaryButton
                    disabled={date_seconds == null || loadingData}
                    className="w-fit"
                    onClick={handleConfirmInterventionDate}
                  >
                    Confirmer la date <SmallSpinner loading={loadingData} />
                  </PrimaryButton>
                </div>
                <Space y={10} />
                <div className="flex flew-row gap-2 justify-between">
                  <SecondaryButton className="w-fit" onClick={handleDone}>
                    Déjà traité
                  </SecondaryButton>
                </div>
              </div>
            </div>
          )}
          {orgData.id === folderData.client_id && (
            <div className="flex relative cursor-default flex-col gap-2 rounded-2xl bg-white border border-blue-300 h-fit w-full p-4 mt-4">
              <div className="flex flex-col p-2 w-full">
                <div className="flex flex-col ">
                  <div className=" rounded-xl mb-2 text-shadow_50  text-h3 font-semibold w-fit">
                    Vous avez demandé un RDV
                  </div>

                  <div>
                    <div className=" rounded-xl  text-shadow_50  text-h3  w-fit">
                      Disponibilités
                    </div>
                    <div className=" rounded-xl  text-shadow_50   text-h3  w-fit">
                      {
                        // if type is string display, else convert to str
                        typeof folderData?.startdate === "object"
                          ? dayjs
                              .unix(folderData?.startdate?.seconds)
                              .format("DD/MM/YYYY")
                          : folderData?.startdate
                      }
                      -{" "}
                      {
                        // if type is string display, else convert to str
                        typeof folderData?.enddate === "object"
                          ? dayjs
                              .unix(folderData?.enddate?.seconds)
                              .format("DD/MM/YYYY")
                          : folderData?.enddate
                      }
                    </div>
                    {folderData?.rdv_comment && (
                      <div className=" rounded-xl bg-blue-50 text-shadow_50  mt-2 text-h3  whitespace-pre-line w-full p-2">
                        {folderData?.rdv_comment}
                      </div>
                    )}
                  </div>
                </div>
              </div>
            </div>
          )}
        </div>
      )}
      {isFolderAdmin(orgData, folderData) &&
        access.length === accessdocuments.length && (
          <CustomAccordion title="Accès" userData={userData}>
            <FolderAccessTable
              documents={accessdocuments.map((doc) => doc.name)}
              persons={accesspersons.map((person) => person.name)}
              access={access}
              setAccess={handleAccessChange}
              handleResetAccess={handleResetAccess}
              loading={access_loading}
              handlesetAllAccess={handlesetAllAccess}
            />
            {folderData.master_id === orgData.id && (
              <FolderAdminTable
                persons={accesspersons}
                admins_id={folderData.admins_id}
                handleAdminChange={handleAdminChange}
                loading={adminLoading}
                folderData={folderData}
              />
            )}
          </CustomAccordion>
        )}
      <CustomAccordion userData={userData} title="Dropzone">
        <Dropzone3
          onDrop={onDropZone}
          files={dropped_files || []}
          selected_files={selected_dropped_files}
          setSelectedDroppedFiles={setSelectedDroppedFiles}
          onDelete={onDelete}
          loading={loading_drop}
        ></Dropzone3>
      </CustomAccordion>
    </>
  );
};
